import { render, staticRenderFns } from "./ChooseNumberOfQuestions.vue?vue&type=template&id=0b6d0c29&scoped=true&"
import script from "./ChooseNumberOfQuestions.vue?vue&type=script&lang=js&"
export * from "./ChooseNumberOfQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ChooseNumberOfQuestions.vue?vue&type=style&index=0&id=0b6d0c29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d0c29",
  null
  
)

export default component.exports